import { motion } from "framer-motion";

export const NotFound = () => (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#F8FAFC] px-6 text-center" data-testid="not-found-page">
        <motion.img
            src="/brand/app-icon-512.webp"
            alt="TheraOffice logo"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            className="h-24 w-24 rounded-3xl shadow-[0_30px_80px_rgba(3,42,68,0.2)]"
        />
        <p className="font-display mt-10 text-7xl italic text-[#0D9488] md:text-8xl">404</p>
        <h1 className="font-display mt-6 text-3xl tracking-tight text-[#0F172A] md:text-4xl">
            Η σελίδα δεν βρέθηκε
        </h1>
        <p className="mt-4 max-w-md text-base leading-relaxed text-[#475569]">
            The page you are looking for does not exist. Ίσως το link είναι παλιό ή υπάρχει κάποιο λάθος στη διεύθυνση.
        </p>
        <a
            href="/"
            className="mt-10 rounded-full bg-[#032A44] px-7 py-4 text-sm font-bold text-white transition-colors duration-300 hover:bg-[#01537B]"
            data-testid="not-found-home-button"
        >
            Επιστροφή στην αρχική
        </a>
    </div>
);
